import step1 from './image_step 1.png';
import step2 from './image_step 2.png';
import step3 from './image_step 3.png';
import step4 from './image_step 4.png';
import step5 from '@/assets/images/helpImage.png';

const images = [step1, step2, step3, step4, step5];

export default images;
